import { Box, Popper, Typography } from '@mui/material';
import { ts } from 'src/utils/translate';
import { theme } from 'src/theme/mui-theme';

interface FirstOfferReadyModalProps {
    anchorEl: HTMLElement | null;
}

export function FirstOfferReadyModal({ anchorEl }: FirstOfferReadyModalProps) {
    const blue = theme.palette.primary.main;
    const white = theme.palette.common.white;

    return (
        <Popper
            open={anchorEl != null}
            anchorEl={anchorEl}
            placement="left"
            sx={{ zIndex: 10000 }}
            modifiers={[{ name: 'offset', options: { offset: [0, 15] } }]}
        >
            <Box
                sx={{
                    maxWidth: 300,
                    backgroundColor: blue,
                    p: '20px 25px',
                    borderRadius: 2,
                    position: 'relative',
                    boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.3)',
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        right: '-15px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        width: 0,
                        height: 0,
                        borderTop: '15px solid transparent',
                        borderBottom: '15px solid transparent',
                        borderLeft: `15px solid ${blue}`,
                    },
                }}
            >
                <Typography sx={{ color: white, fontWeight: 600, fontSize: 18, mb: 1.25 }}>
                    {ts('first_offer_ready_title', 'Your first offer is ready!')}
                </Typography>
                <Typography sx={{ color: white, fontSize: 14, mt: 2 }}>
                    {ts('first_offer_ready_text', 'Your customized offer is ready.')}
                </Typography>
                <Typography sx={{ color: white, fontSize: 14, mt: 0.5 }}>
                    {ts('first_offer_ready_click', 'View and edit it by clicking here!')}
                </Typography>
            </Box>
        </Popper>
    );
}
